import { __decorate, __metadata } from "tslib";
import { Title } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { GenderType } from '../../enums/GenderType.js';
import { PartyResourceType } from '../../enums/PartyResourceType.js';
import { PartyType } from '../../enums/PartyType.js';
import { NAME_PATTERN } from '../../utils/regex.js';
export class PartyPersonalDetails extends BaseMessage {
    partyId;
    partyType;
    partyResourceType;
    foreNames;
    firstName;
    secondName;
    thirdName;
    initials;
    lastName;
    title;
    generationSuffix;
    birthDate;
    deathDate;
    deathNotifiedDate;
    gender;
}
__decorate([
    Field.number({
        description: 'The OCIS party id.',
        numberType: 'number',
        required: true,
    }),
    __metadata("design:type", Number)
], PartyPersonalDetails.prototype, "partyId", void 0);
__decorate([
    Field.enum({
        enum: PartyType,
        description: 'This attribute will identify if the Party is Individual or Organisation',
        required: true,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "partyType", void 0);
__decorate([
    Field.enum({
        enum: PartyResourceType,
        description: 'This attribute determines the type (or variation) of the Party resource defintion used.',
        required: true,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "partyResourceType", void 0);
__decorate([
    Field.array({
        items: {
            type: 'string',
            example: 'Juliet',
        },
        required: true,
        description: 'The first, second and third given (or fore) name of a person.',
    }),
    __metadata("design:type", Array)
], PartyPersonalDetails.prototype, "foreNames", void 0);
__decorate([
    Field.string({
        description: 'The first given (or fore) name of a person',
        required: true,
        maxLength: 30,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "firstName", void 0);
__decorate([
    Field.string({
        description: 'The second given (or fore or middle) name',
        required: true,
        maxLength: 30,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "secondName", void 0);
__decorate([
    Field.string({
        description: 'The third given (or fore or middle) name',
        required: true,
        maxLength: 30,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "thirdName", void 0);
__decorate([
    Field.array({
        items: {
            type: 'string',
            example: 'J',
        },
        required: true,
        description: 'Initials of Person, including first initial',
    }),
    __metadata("design:type", Array)
], PartyPersonalDetails.prototype, "initials", void 0);
__decorate([
    Field.string({
        description: 'surname',
        required: true,
        maxLength: 80,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "lastName", void 0);
__decorate([
    Field.enum({
        enum: Title,
        description: 'The title of a person.',
        required: true,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "title", void 0);
__decorate([
    Field.string({
        description: 'Values can include "JNR"  or "SNR" or number of generation eg III etc.',
        required: false,
        maxLength: 20,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "generationSuffix", void 0);
__decorate([
    Field.string({
        description: 'Date on which the person was born',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "birthDate", void 0);
__decorate([
    Field.string({
        description: 'Confirmed (evidenced) date on which the Individual died',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "deathDate", void 0);
__decorate([
    Field.string({
        description: 'Date on which LBG was advised of the Individual being dead. ',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "deathNotifiedDate", void 0);
__decorate([
    Field.enum({
        enum: GenderType,
        description: 'Gender of the Person',
        required: true,
    }),
    __metadata("design:type", String)
], PartyPersonalDetails.prototype, "gender", void 0);
//# sourceMappingURL=PartyPersonalDetails.js.map